/**
 * @file CancelDeleteJobDialog.jsx
 * @description CancelDeleteJobDialog component for displaying and managing cancel/delete job dialog.
 * @component CancelDeleteJobDialog
 * @exports CancelDeleteJobDialog - Main component for displaying and managing cancel/delete job dialog.
 */

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { JOB_STRINGS, JOB_ACTIONS } from "../../../common/constants/ivrModule/jobConstants.js";
import { STRINGS, VARIANTS, BUTTON_COLORS } from "../../../common/constants/commonConstants.js";

const CancelDeleteJobDialog = ({ open, action, message, validJobs, onConfirm, onClose }) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>
                {action === JOB_ACTIONS.DELETE ? JOB_STRINGS.CONFIRM_DELETE : JOB_STRINGS.CONFIRM_CANCEL}
            </DialogTitle>
            <DialogContent>
                {message}
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    variant={VARIANTS.CONTAINED}
                    color={BUTTON_COLORS.PRIMARY}
                >
                    {STRINGS.CLOSE}
                </Button>
                {validJobs > 0 && (
                    <Button
                        onClick={onConfirm}
                        variant={VARIANTS.CONTAINED}
                        color={BUTTON_COLORS.ERROR}
                    >
                        {STRINGS.CONFIRM}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default CancelDeleteJobDialog